export const seasonLabels = () => {
  const start = 2005;
  const end = 2024;
  const labels = [];

  for (let year = start; year <= end; year += 1) {
    labels.push(formatSeason(year));
  }

  return labels;
};

export const formatSeason = (year) => {
  const nextShort = String((Number(year) + 1) % 100).padStart(2, "0");
  return `${year}-${nextShort}`;
};

export const parseSeasonLabel = (label) => {
  const [year] = label.split("-");
  return Number(year);
};
